import { render, staticRenderFns } from "./SMSCampaignList.vue?vue&type=template&id=47ebf4d5&scoped=true&"
import script from "./SMSCampaignList.vue?vue&type=script&lang=js&"
export * from "./SMSCampaignList.vue?vue&type=script&lang=js&"
import style0 from "./SMSCampaignList.vue?vue&type=style&index=0&id=47ebf4d5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ebf4d5",
  null
  
)

export default component.exports